function isInternationalLeague(item) {
    if (!item) return false;

    const liga = String(item.liga || "").toUpperCase();
    return !liga.includes("LUB");
}

function getAge(liga, nacimiento) {
    if (!liga || !nacimiento) return "-";
    const yearMatch = String(liga).match(/(\d{4})/);
    const birthYear = new Date(nacimiento).getFullYear();

    if (!yearMatch || Number.isNaN(birthYear)) return "-";
    return Number(yearMatch[1]) - birthYear;
}

function HeaderRow({ sectionTitle = "Liga" }) {
    return (
        <tr className="bg-[#102216] text-xs md:text-sm font-bold uppercase tracking-wider text-slate-500 border-y border-white/10">
            <th className="px-4 py-3 text-left">{sectionTitle}</th>
            <th className="px-2 py-3 text-center">Edad</th>
            <th className="px-2 py-3 text-center">Partidos</th>
            <th className="px-2 py-3 text-center">Ganados</th>
            <th className="px-2 py-3 text-center">Perdidos</th>
            <th className="px-2 py-3 text-center">Gan %</th>
        </tr>
    );
}

function DataRow({ item, nacimiento }) {
    return (
        <tr className="hover:bg-white/5 transition-colors">
            <td className="px-4 py-2.5 font-medium text-green-400">{item.liga || "-"}</td>
            <td className="px-2 py-2.5 text-center">{getAge(item.liga, nacimiento)}</td>
            <td className="px-2 py-2.5 text-center">{item.partidos ?? 0}</td>
            <td className="px-2 py-2.5 text-center">{item.ganados ?? 0}</td>
            <td className="px-2 py-2.5 text-center">{item.perdidos ?? 0}</td>
            <td className="px-2 py-2.5 text-center">{item.winPerc ?? "0%"}</td>
        </tr>
    );
}

export default function TecnicoTotalsTable({ totals = [], careerTotals, nacimiento, isCollapsed = false, onToggleCollapse }) {
    if (!totals.length && !careerTotals) {
        return null;
    }

    const localTotals = totals.filter((item) => !isInternationalLeague(item));
    const internationalTotals = totals.filter((item) => isInternationalLeague(item));

    return (
        <section className="mb-12">
            <div className={`flex items-center justify-between gap-3 border border-white/10 bg-[#102216] px-4 py-1.5 ${isCollapsed ? "rounded-lg" : "rounded-t-lg"}`}>
                <h3 className="text-base md:text-lg font-bold text-slate-200">Torneos Dirigidos</h3>
                <button
                    type="button"
                    onClick={onToggleCollapse}
                    className="text-xs font-semibold uppercase tracking-wide text-slate-300 transition-colors hover:text-green-400"
                >
                    {isCollapsed ? "Mostrar" : "Ocultar"}
                </button>
            </div>
            <div className={`grid transition-[grid-template-rows,opacity] duration-300 ease-out ${isCollapsed ? "grid-rows-[0fr] opacity-0" : "grid-rows-[1fr] opacity-100"}`}>
                <div className="min-h-0 overflow-hidden">
                    <div className="-mt-px overflow-x-auto rounded-b-xl border-x border-b border-white/10 bg-[#102216]">
                        <table className="w-full text-left text-xs sm:text-sm">
                    <thead>
                        <HeaderRow />
                    </thead>
                    <tbody className="divide-y divide-white/10 text-slate-300">
                        {localTotals.map((item, index) => (
                            <DataRow key={`tec-local-${item.liga}-${index}`} item={item} nacimiento={nacimiento} />
                        ))}

                        {internationalTotals.length > 0 && localTotals.length > 0 ? (
                            <HeaderRow sectionTitle="Internacional" />
                        ) : null}

                        {internationalTotals.map((item, index) => (
                            <DataRow key={`tec-int-${item.liga}-${index}`} item={item} nacimiento={nacimiento} />
                        ))}

                        {careerTotals ? (
                            <tr className="bg-green-500/10 text-slate-100 border-t border-green-400/30">
                                <td className="px-4 py-3 uppercase font-bold">Carrera</td>
                                <td className="px-2 py-3 text-center">-</td>
                                <td className="px-2 py-3 text-center">{careerTotals.partidos ?? 0}</td>
                                <td className="px-2 py-3 text-center">{careerTotals.ganados ?? 0}</td>
                                <td className="px-2 py-3 text-center">{careerTotals.perdidos ?? 0}</td>
                                <td className="px-2 py-3 text-center">{careerTotals.winPerc ?? "0%"}</td>
                            </tr>
                        ) : null}
                    </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </section>
    );
}
